enum CashType {
    Standard = 1,
    EquityRelease = 2
}

export default CashType;
